import { render, staticRenderFns } from "./MoreProfileItem.vue?vue&type=template&id=4aeaa510&scoped=true&"
import script from "./MoreProfileItem.vue?vue&type=script&lang=ts&"
export * from "./MoreProfileItem.vue?vue&type=script&lang=ts&"
import style0 from "./MoreProfileItem.vue?vue&type=style&index=0&id=4aeaa510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeaa510",
  null
  
)

export default component.exports